<template>
    <div style="height: 100%">
        <!--        Header Beginner-->
        <v-toolbar flat color="transparent">
            <v-toolbar-title>Customers</v-toolbar-title>
            <v-spacer></v-spacer>
            <div class="mx-3 fl">
                <download-excel class="btn btn-default" :data="rows" :fields="json_fields" worksheet="Customers"
                    :name="fileName" :before-generate="exportCustomers">
                    <v-btn color="primary">Export Customers</v-btn>
                </download-excel>
            </div>
            <div v-if="[1, 2, 4, 8].includes(role)" class="mx-3 fl">
                <b-button @click="uuid = null; dataForm = true" variant="outline-primary">Add Customer</b-button>
            </div>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line clearable hide-details
                :style="{ 'max-width': ($vuetify.breakpoint.xs) ? '135px' : '320px' }"
                @change="(getCustomers(true))"></v-text-field>
        </v-toolbar>
        <!--        Header End-->

        <!--<editor-fold desc="Filters">-->
        <div class="mx-10">
            <v-row>
                <v-col>
                    <v-combobox :items="programs" v-model="program" clearable item-value="uuid" item-text="name"
                        label="Programs" data-vv-name="programs" :error-messages="errors.collect('')"
                        @change="(changePrograms($event))" @click:clear="clearedProgram($event)"></v-combobox>
                </v-col>
                <v-col>
                    <v-combobox :items="brands" v-model="brand" clearable item-value="uuid" item-text="name" label="Brands"
                        :error-messages="errors.collect('')" @change="(changeBrands($event))"
                        @click:clear="clearedBrands($event)"></v-combobox>
                </v-col>
                <v-col>
                    <v-combobox :items="countries" v-model="country" clearable item-value="name" item-text="name"
                        label="Countries" :error-messages="errors.collect('')" @change="(changeCountries($event))"
                        @click:clear="clearedCountries($event)"></v-combobox>
                </v-col>
                <v-col>
                    <v-combobox :items="regions" v-model="region" clearable item-value="name" item-text="name"
                        label="Regions" :error-messages="errors.collect('')" @change="(changeRegions($event))"
                        @click:clear="clearedRegions($event)"></v-combobox>
                </v-col>
                <v-col>
                    <v-combobox :items="cities" v-model="city" clearable item-value="name" item-text="name" label="Cities"
                        :error-messages="errors.collect('')" @change="(changeCities($event))"
                        @click:clear="clearedCities($event)"></v-combobox>
                </v-col>
                <v-col>
                    <v-combobox :items="genders" v-model="gender" clearable item-value="value" item-text="text"
                        label="Genders" :error-messages="errors.collect('')" @change="(changeGenders($event))"
                        @click:clear="clearedGenders($event)"></v-combobox>
                </v-col>
            </v-row>
        </div>
        <!--</editor-fold>-->

        <v-data-table :mobile-breakpoint="0" class="mb-5" v-model="selected" :headers="headers" :items="rows"
            :loading="loading" loading-text="Loading... Please wait" item-key="uuid" :options.sync="options"
            :show-select="settings.select_all" footer-props.prev-icon="arrow_left" footer-props.next-icon="arrow_right"
            header-props.sort-icon="arrow_drop_down" :items-per-page="options.itemsPerPage" hide-default-footer
            @current-items="currentItems = $event">

            <template :slot="'item.' + item.value" slot-scope="props" v-for="(item, index) in headers">
                <div v-if="index != Object.keys(headers).length - 1 || !settings.actions" :style="item.style">
                    <div v-if="item.type === 'boolean'" class="text-xs-center">
                        <div v-if="props.item[item.value] === 1 || props.item[item.value] === '1'">
                            <v-icon small>check</v-icon>
                        </div>
                        <div v-else>
                            <v-icon small>close</v-icon>
                        </div>
                    </div>
                    <div v-else-if="item.type === 'link'">
                        <a :href="props.item[item.value]" target="_blank">{{
                            props.item[item.value].replace('http://', '').replace('https://', '').replace('//', '')
                        }}</a>
                    </div>
                    <div v-else-if="item.type === 'campaign_link'">
                        <a :href="props.item[item.value] + '/staff'" target="_blank" style="font-weight: bold">Staff
                            Area</a> | <a :href="props.item[item.value]" target="_blank">{{
                                props.item[item.value].replace('http://', '').replace('https://', '').replace('//', '')
                            }}</a>
                    </div>
                    <div v-else-if="item.type === 'number' || item.type === 'currency'">
                        <div class="text-xs-right">{{ props.item[item.value] }}</div>
                    </div>
                    <div v-else-if="item.type === 'date_time'">
                        <span
                            v-html="parseDateTime(props.item[item.value], item.format, item.color_is_past, item.color_is_future)"></span>
                    </div>
                    <div v-else-if="item.type === 'image'">
                        <v-img :src="props.item[item.value]" class="elevation-1 my-3 d-block" v-if="props.item[item.value]"
                            contain :max-width="item.max_width" :max-height="item.max_height"></v-img>
                    </div>
                    <div v-if="item.value === 'avatar'" class="text-xs-center">
                        <v-avatar :tile="false" size="32" color="grey lighten-4">
                            <v-img :src="props.item[item.value]" v-if="props.item[item.value]"></v-img>
                        </v-avatar>
                    </div>
                    <div v-else @click="goToProfile(item, props.item.uuid)">
                        <span v-if="item.value === 'name'" style="cursor: pointer;">{{ props.item[item.value] }}</span>
                        <span v-else>{{ props.item[item.value] }}</span>
                    </div>
                </div>
                <div v-if="index == Object.keys(headers).length - 1 && settings.actions">

                    <div class="action-menu-wrapper d-flex">
                        <span v-for="(item, index) in actions">
                            <v-tooltip top v-if="item.action">
                                <template v-slot:activator="{ on }">
                                    <v-btn class="mr-1 mt-0 mb-0" v-on="on" :dark="item.dark" :color="item.color" icon small
                                        @click="executeAction(item.action, props.item.uuid)">
                                        <v-icon small>{{ item.icon }}</v-icon></v-btn>
                                </template>
                                <span>{{ item.text }}</span>
                            </v-tooltip>
                            <v-divider v-else vertical class="grey lighten-2" style="vertical-align: middle;"></v-divider>
                        </span>
                    </div>
                </div>
            </template>

            <template v-slot:footer>
                <v-row>
                    <v-col :cols="8">
                        <div v-if="[1, 2, 4, 8].includes(role)" class="ma-3">
                            <v-btn v-if="settings.select_all" depressed small color="error"
                                :disabled="disableDeleteSelected" @click="deleteSelected">{{ $t('delete_selected') }}
                            </v-btn>
                        </div>
                    </v-col>
                    <v-col :cols="2">
                        <v-select :items="itemsPerPageOptions" v-model="options.itemsPerPage" label="Rows per page"
                            @change="getCustomers(true)"></v-select>
                    </v-col>
                    <v-col :cols="2">

                        <v-pagination v-model="options.page" :length="pageCount" :page="currentPage"
                            @input="getCustomers()"></v-pagination>
                    </v-col>
                </v-row>
            </template>

            <template v-slot:no-data>
                <div v-if="!loading" class="text-xs-center">
                    Your search and/or filter found no results.
                </div>
                <div v-if="loading" class="text-xs-center">
                    Loading data
                </div>
            </template>
        </v-data-table>


        <v-dialog persistent :width="settings.dialog_width || 480" :fullscreen="$vuetify.breakpoint.xsOnly"
            v-model="dataForm" :dataForm="dataForm" @keydown.esc="dataForm = false">
            <data-form v-if="dataForm" v-on:data-list-events="dataListEvents($event)" :model="model"
                :uuid="uuid"></data-form>
        </v-dialog>
    </div>
</template>
<script>
import _ from "lodash";

export default {
    data() {
        let actions_form = [{
            action: "link",
            color: "secondary",
            dark: false,
            icon: "link",
            text: "Link",
        }];
        if ([1, 2, 4, 8].includes(this.$auth.user().role)) {
            actions_form.push(
                {
                    action: "edit",
                    color: "secondary",
                    dark: false,
                    icon: "edit",
                    text: "Edit",
                },
                {
                    action: "delete",
                    color: "secondary",
                    dark: true,
                    icon: "delete",
                    text: "Delete",
                });
        }

        return {
            role: this.$auth.user().role,
            json_fields: {
                "Name": "name",
                "Email": "email",
                "Date Joined": "created_at",
                "Last Active": "updated_at",
                "Card Number": "card_number",
                "Phone Number": "phone",
            },
            currentItems: [],
            model: "App\\Customer",
            programs: [],
            program: null,
            brands: [],
            brand: null,
            countries: [],
            country: null,
            regions: [],
            region: null,
            cities: [],
            city: null,
            genders: [{
                value: 'male',
                text: 'Male',
            }, {
                value: 'female',
                text: 'Female',
            }],
            gender: null,
            loading: true,
            disableDeleteSelected: true,
            search: '',
            openMenu: [],
            selected: [],
            settings: {
                actions: true,
                actions_width: "100px",
                create: true,
                select_all: true,
            },
            dataForm: false,
            actions: actions_form,
            translations: [],
            rows: [],
            filters: {},
            options: {
                sortBy: ['name'],
                sortDesc: [false],
                page: 1,
                itemsPerPage: 10,
                filters: []
            },
            pageCount: 0,
            currentPage: 0,
            itemsPerPageOptions: [10, 25, 50, 75, 100],
            headers: [
                {
                    text: 'Name',
                    align: 'left',
                    value: 'name',
                },
                {
                    text: 'E-mail',
                    align: 'left',
                    value: 'email',
                },
                {
                    text: 'Phone Number',
                    align: 'left',
                    value: 'phone',
                },
                {
                    text: 'Card Number',
                    align: 'left',
                    value: 'card_number',
                },
                {
                    text: 'Date Joined',
                    align: 'center',
                    value: 'created_at',
                },
                {
                    text: 'Last Active',
                    align: 'center',
                    value: 'updated_at',
                },
                {
                    text: 'Actions',
                    align: 'center',
                    sortable: false,
                    value: 'actions',
                },
            ],
        }
    },
    created() {
        this.getCustomers()
        this.getPrograms()
    },
    computed: {
        fileName() {
            return 'customers_' + moment(new Date()).format('YYYYMMDDHHMMSS') + '.xls';
        },
        app() {
            return this.$store.getters.app
        },
    },
    watch: {
        selected() {
            this.disableDeleteSelected = (this.selected.length > 0) ? false : true;
        }
    },
    methods: {
        exportCustomers() {
            const sort_by = (property, desc) => {
                let sortOrder = desc ? -1 : 1;
                return function (a, b) {
                    /* next line works with strings and numbers,
                     * and you may want to customize it to your needs
                     */
                    let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                    return result * sortOrder;
                }
            }
            this.rows.sort(sort_by(this.options.sortBy[0], this.options.sortDesc[0]));
        },
        dataListEvents(event) {
            if (event.closeDialog) {
                this.dataForm = false
            }
            if (event.reload) {
                this.getCustomers()
            }
        },
        getPrograms() {
            axios
                .get('/app/getprograms')
                .then(response => {
                    this.programs = response.data.programs;
                });
        },
        getBrands(program) {
            axios.get('/businessbyprogramid/' + program)
                .then(response => {
                    let places = response.data.places;
                    this.brands = places.map(place => {
                        return { id: place.pk, name: place.val };
                    });
                });
        },
        getCustomers(reset = false) {
            this.loading = true
            const params = this.filters;

            if (this.options.page === undefined) {
                this.options.page = 1;
            }

            if (reset) {
                this.options.page = 1;
            }

            axios.get('/customers/?page=' + this.options.page + '&pagesize=' + this.options.itemsPerPage + "&s=" + encodeURIComponent(this.search), { params })
                .then(res => {
                    this.currentPage = res.data.current_page;
                    this.pageCount = res.data.last_page;

                    this.rows = res.data.data
                    this.loading = false
                })
                .catch(err => console.log(err))
                .finally(() => this.loading = false)
        },
        deleteSelected() {
            if (this.selected.length > 0) {
                let uuids = this.selected
                uuids = _.map(uuids, function (o) {
                    return o.uuid;
                });
                this.deleteRecords(uuids)
            }
        },
        openMenuToogle(index) {
            for (var i in this.openMenu) {
                if (i !== index) {
                    this.$set(this.openMenu, i, false);
                }
            }

            if (!this.openMenu[index]) {
                this.$set(this.openMenu, index, true);
            } else {
                this.$set(this.openMenu, index, false);
            }
            // this.openMenu[index] = !this.openMenu[index];
        },
        goToProfile(item, uuid) {
            this.$router.push({ name: 'customer.profile', params: { uuid: uuid } })
        },
        executeAction(action, uuid) {
            if (action === 'delete') {
                this.uuid = null
                this.deleteRecords([uuid])
            }
            if (action === 'link') {
                this.uuid = uuid;
                this.$router.push({ name: 'customer.profile', params: { uuid: this.uuid } })
            }
            if (action === 'edit') {
                this.uuid = uuid
                this.dataForm = true
            }
        },
        deleteRecords(uuids) {
            this.$root.$confirm(this.$t('delete'), this.$t('confirm_delete'))
                .then((confirm) => {
                    if (confirm) {
                        axios.post('/app/data-table/delete', {
                            locale: this.$i18n.locale,
                            model: this.model,
                            uuids: uuids
                        })
                            .then(res => {
                                if (res.data.status === 'success') {
                                    this.getCustomers()
                                    this.$root.$snackbar(this.$t('items_deleted', { items: res.data.deleted }))
                                }
                            })
                            .catch(err => {
                                if (err.response.data.status === 'error') {
                                    this.$root.$snackbar(err.response.data.msg)
                                    this.reloadData()
                                }
                            })
                            .finally(() => this.loading = false)
                    }
                })
        },
        changePrograms(event) {
            if (!event) {
                return
            }
            //Clear data
            this.clearedBrands()
            //Add filter
            this.filters['program'] = event.id;
            //Get data from Back end
            this.getBrands(event.uuid)
            this.getCustomers()
        },
        changeBrands(event) {
            if (!event) {
                return
            }
            //Clear data
            this.clearedBrands()
            //Add filter
            this.filters['brand'] = event.id
            //Get data from Backend
            //GET Countries
            axios
                .get('/countriesbybusiness/' + event.id)
                .then(response => {
                    this.countries = response.data.country;
                })
            //Get customers
            this.getCustomers()
        },
        changeCountries(event) {
            if (!event) {
                return
            }
            //Clear data
            this.clearedCountries()
            //Add filter
            let countryName = event.name
            this.filters['country'] = countryName
            //Get data from backend
            axios
                .get('/regionsbycountry/' + countryName)
                .then(response => {
                    this.regions = response.data.places;
                })
            //Get customers
            this.getCustomers()
        },
        changeRegions(event) {
            if (!event) {
                return
            }
            //Clear data
            this.clearedRegions()
            //Add filter
            let regionName = event.name
            this.filters['region'] = regionName
            //Get data from back end
            axios
                .get('/citiesbyregion/' + this.filters['country'] + '/' + regionName)
                .then(response => {
                    this.cities = response.data.places;
                });
            //Get customers
            this.getCustomers()
        },
        changeGenders(event) {
            if (!event) {
                return
            }
            //Clear data
            this.filters['gender'] = event.value
            //Get data from back end
            this.getCustomers()
        },
        changeCities(event) {
            if (!event) {
                return
            }
            this.clearedCities()
            //Add filter
            this.filters['city'] = event.name
            //Get customers
            this.getCustomers()
        },
        clearedProgram(event) {
            delete this.filters['program']
            this.brands = []
            this.brand = null
            this.clearedBrands()
            this.clearedCountries()
            this.clearedRegions()
            this.clearedCities()
            if (event) {
                this.getCustomers()
            }
        },
        clearedBrands(event) {
            delete this.filters['brand']
            this.countries = []
            this.country = null
            this.clearedCountries()
            this.clearedRegions()
            this.clearedCities()
            if (event) {
                this.getCustomers()
            }
        },
        clearedCountries(event) {
            delete this.filters['country']
            this.regions = []
            this.region = null
            this.clearedRegions()
            this.clearedCities()
            if (event) {
                this.getCustomers()
            }
        },
        clearedRegions(event) {
            delete this.filters['region']
            this.cities = []
            this.city = null
            this.clearedCities()
            if (event) {
                this.getCustomers()
            }
        },
        clearedCities(event) {
            delete this.filters['city']
            if (event) {
                this.getCustomers()
            }
        },
        clearedGenders(event) {
            delete this.filters['gender']
            if (event) {
                this.getCustomers()
            }
        }
    }
}
</script>
